import { FC } from 'react';
import Link from 'next/link';
import styles from './SectionTitleArrow.module.scss';

interface ISectionTitleProps {
  name: string;
  alias: string;
  extraClassName?: string;
}

const SectionTitleArrow: FC<ISectionTitleProps> = ({ name, alias, extraClassName }) => {
  const getHeadingClassNames = () => (extraClassName ? `${styles.titleArrow} ${styles[`${extraClassName}`]}` : styles.titleArrow);

  return (
    <h2 className={getHeadingClassNames()}>
      <Link prefetch={false} href={alias}>
        {name}
      </Link>
    </h2>
  );
};

export default SectionTitleArrow;
